import { SongRepository } from '@/context/global/api/repository/song';
import { AxiosInstance } from 'axios';

export const SongAPI = (axios: AxiosInstance): SongRepository => {
  return {
    PostSetSongFollow(songId: number, like: boolean) {
      return axios.post(
        `/web/content/song/follow`,
        {
          songId: songId,
          isFollowing: like,
        },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );
    },

    PostStatHeartBeat(songId, deviceId, sessionId) {
      return axios.post(`/web/content/song/record/play`, {
        songId,
        deviceId,
        session: sessionId,
        clientType: 'website',
      });
    },

    PostSongConcurrentSessionHeartBeat(sessionId, deviceId) {
      return axios.post(`/web/content/song/session`, {
        deviceId,
        session: sessionId,
        clientType: 'website',
      });
    },
  };
};
